import React, { useState } from "react";

import edit from "../../../assets/icons/edit-2.svg";
import trash from "../../../assets/icons/trash.png";
import { getScheduleTag } from "../utils";
import { controller } from "../controller";
import { message } from "antd";

export default function ActionItem({action, onDelete, deleting, onEdit}) {

  return (
      <div style={{ padding: "10px 20px", border: "1px solid #E0DDF7", borderRadius: 10, display: "flex", flexDirection: "column", gap: 10 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span style={{ fontSize: 14, color: "#6B43B5", textTransform: "capitalize" }}>{action.action_type}</span>

          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img src={edit} alt="edit" style={{ width: 16, height: 16, cursor: 'pointer' }} onClick={() => onEdit(action.id)} />
            <img src={trash} alt="remove" style={{ width: 16, height: 16, cursor: 'pointer'}} onClick={() => onDelete(action.id)} loading={deleting}/>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
          <span style={{ fontSize: 12 }}>Schedule</span>

          <div
            style={{
              backgroundColor: "#EEEDFA",
              color: "#6b43B5",
              padding: "5px 10px",
              borderRadius: 100,
              textWrap: "nowrap",
              whiteSpace: "nowrap",
              fontSize: 12,
              textTransform: "capitalize",
            }}
          >
            {getScheduleTag(action.action_trigger)} 
          </div>
        </div>
      </div>
  );
}
